import React, { useEffect, useState } from "react";
import { Autocomplete, Grid, TextField, Typography, Checkbox, FormControlLabel } from "@mui/material";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { sendDataWithPost } from "../../../services/services";
import FormDialog from "../../../components/FormDialog";
import { showSuccessMsg } from "../../../utils/toast";

const CreateQuickPayment = ({ data = {}, onClose, cb }) => {
  const {
    id,
    terminal,
    capture,
    callback_url,
    is_active,
  } = data?.details || {};

  const [terminalList, setTerminalList] = useState(data?.terminal || []);

  return (
    <Formik
      initialValues={{
        terminal: terminal || "",
        capture: capture || "",
        callback_url: callback_url || "",
        is_active: is_active || "",
      }}
      validationSchema={Yup.object().shape({
        terminal: Yup.object().required("Terminal is required"),
        callback_url: Yup.string().required("Callback URL is required"),
      })}
      onSubmit={async (values, { setSubmitting }) => {
        let url = "/merchant/terminal/create_quick_payment/";

        if(id) {
          url = "/merchant/terminal/update_quick_payment/";
        }

        let payload = {
          ...values,
          terminal_id: values.terminal?.id,
          capture: values.capture,
          callback_url: values.callback_url,
          is_active: values.is_active,
        };

        if(id) {
          payload = {
            merchant_quick_payment_id: id,
            is_active: values.is_active,
            callback_url: values.callback_url,
            capture: values.capture,
          }
      }

        await sendDataWithPost(url, payload, null, null, () => {
          showSuccessMsg();
          cb();
          onClose();
        });
        setSubmitting(false);
      }}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
        } = props;
        return (
          <FormDialog
            open={true}
            maxWidth="md"
            onClose={onClose}
            title={
              id ? "Edit Quick Payment" : "Add Quick Payment"
            }
            scroll="paper"
            handleSubmit={handleSubmit}
            loading={isSubmitting}
          >
            <Form autoComplete="off" noValidate>
              <Grid item sm={12} xs={12} sx={{ py: 2, px: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Typography variant="h6" my={1}>
                    Quick Payment Info
                  </Typography>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <Typography align="right">
                        Terminal ID {!id && "*"}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Autocomplete
                        options={
                          terminalList?.map((item) => ({
                            id: item,
                            label: item,
                          })) || []
                        }
                        value={values.terminal.terminal_id}
                        loadingText="Loading..."
                        disabled={isSubmitting}
                        onChange={(e, value) => {
                          setFieldValue(
                            "terminal",
                            !value ? "" : { id: value.id, label: value.label }
                          );
                        }}
                        isOptionEqualToValue={(option, value) => {
                          return option.id === value.id;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="terminal"
                            size="small"
                            fullWidth
                            placeholder="Search..."
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.terminal && errors.terminal
                            )}
                            helperText={touched.terminal && errors.terminal}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <Typography align="right">
                        Capture
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.capture || false}
                            onChange={(e) => {
                              setFieldValue("capture", e.target.checked);
                            }}
                            disabled={isSubmitting}
                            name="capture"
                            value={values.capture}
                          />
                        }
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography align="right">
                        Callback URL
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Callback URL"
                        margin="dense"
                        fullWidth
                        id="callback_url"
                        name="callback_url"
                        size="small"
                        color="secondary"
                        value={values.callback_url}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        error={Boolean(
                          touched.callback_url &&
                            errors.callback_url
                        )}
                        helperText={
                          touched.callback_url &&
                          errors.callback_url
                        }
                        disabled={isSubmitting}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography align="right">
                        Active
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.is_active || false}
                              onChange={(e) => {
                                setFieldValue("is_active", e.target.checked);
                              }}
                              disabled={isSubmitting}
                              name="is_active"
                              value={values.is_active}
                            />
                          }
                        />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormDialog>
        );
      }}
    </Formik>
  );
};

export default CreateQuickPayment;
